import * as React from "react";

function ToggleState1() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="10" viewBox="0 0 18 10">
    <g id="State_1_-_Basic_Panel" data-name="State 1 - Basic Panel" transform="translate(-61 -489)">
      <g id="Group_54797" data-name="Group 54797" transform="translate(-161 -178)">
        <rect id="Rectangle_10699" data-name="Rectangle 10699" width="18" height="10" rx="5" transform="translate(222 667)" fill="#c4c4c4"/>
      </g>
      <circle id="Ellipse_2315" data-name="Ellipse 2315" cx="3" cy="3" r="3" transform="translate(63 491)" fill="#fff"/>
    </g>
  </svg>
  
  );
}

export default ToggleState1;